import * as React from "react";
import styled, { css } from "styled-components";
import { StyledText } from "../Text";
import { StyledHeading } from "../Heading";
var StyledTruncate = styled.div.withConfig({
  displayName: "Truncate__StyledTruncate",
  componentId: "jwxsw1-0"
})(["min-width:0;", ";"], function (_ref) {
  var maxWidth = _ref.maxWidth;
  return css(["flex:0 1 ", ";max-width:", ";"], maxWidth === "none" ? "100%" : maxWidth, maxWidth);
});
var StyledTruncateContent = styled.div.withConfig({
  displayName: "Truncate__StyledTruncateContent",
  componentId: "jwxsw1-1"
})(["&,", ",", "{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"], StyledText, StyledHeading);

var Truncate = function Truncate(_ref2) {
  var children = _ref2.children,
      _ref2$maxWidth = _ref2.maxWidth,
      maxWidth = _ref2$maxWidth === void 0 ? "100%" : _ref2$maxWidth,
      dataTest = _ref2.dataTest;
  return React.createElement(StyledTruncate, {
    maxWidth: maxWidth,
    "data-test": dataTest
  }, React.createElement(StyledTruncateContent, null, children));
};

export default Truncate;